import { useEffect } from "react";


const Wenxin: React.FC = () => {

    useEffect(() => {
        window.location.href = 'https://wenxin.baidu.com/'
    }, []); 
    return (
        <div className='wenxin-page' />
    );
    
};

export default Wenxin;